export const siteConfig = {
  name: 'LaGrange',
  description: 'Ship 10x Faster with LaGrange',

  // Navigation menu items
  mainNav: [
    { key: 'location', href: '/location' },
    { key: 'atelier', href: '/atelier' },
  ],

  // Social media links
  social: {
    instagram: 'https://www.instagram.com/lagrange.prapoutel/',
    facebook: 'https://www.facebook.com/lagrange.prapoutel/',
    whatsapp: 'https://wa.me/33476717226',
  },

  // Contact information
  contact: {
    email: 'hello@lagrange.com',
    phone: '+33476717226',
  },

  // Reservation platform links
  reservation: {
    winter: {
      fr: 'https://lagrangeauxskis-prapoutel.notresphere.com/location-materiel',
      en: 'https://lagrangeauxskis-prapoutel.notresphere.com/en-gb/rental-gear',
    },
    summer: {
      fr: 'https://lagrangeauxskis-prapoutel-velo.notresphere.com/location-materiel',
      en: 'https://lagrangeauxskis-prapoutel-velo.notresphere.com/en-gb/rental-gear',
    },
  },
} as const

export type SiteConfig = typeof siteConfig
